<template>
  <md-card>
    <md-card-header>
      <h4>Agregar pago</h4>
    </md-card-header>

    <md-card-content>
      <md-card>
        <md-card-header>
          <h5>Pagos anteriores</h5>
        </md-card-header>
        <md-card-content>
          <simple-table :tableData="payments" :tableHeaders="headers" :hasActions="false"></simple-table>
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-header>
          <h5>Agregar pago</h5>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>Depósito</label>
                <md-input v-model="form.amount" type="number"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>Dolar</label>
                <md-input v-model="form.exchangePrice" type="number"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-button class="md-success" @click="sendPayment">Enviar</md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </md-card-content>
  </md-card>
</template>

<script>
import { SimpleTable } from "@/components";
import ExtranetService from "../../services/extranet";

export default {
  name: "AddPayment",
  props: {
    package: { type: Number },
  },
  components: { SimpleTable },
  data() {
    return {
      headers: [
        { text: "Depósito", value: "amount" },
        { text: "precio del dolar", value: "dolar" },
        { text: "Fecha", value: "addDate" },
      ],
      payments: [],
      form: {
        package: 0,
        amount: 0.0,
        exchangePrice: 0.0,
      },
    };
  },
  mounted() {
    ExtranetService.dollar2peso("USD").then((response) => {
      this.form.exchangePrice = response.rates.MXN.toFixed(6);
    });
    ExtranetService.getPaymentsPerPackage(this.package).then((response) => {
      this.payments = response;
    });
  },
  methods: {
    sendPayment() {
      this.form.package = this.package;
      if (this.form.amount > 0) {
        ExtranetService.sendPayment(this.form).then((response) => {
          this.$emit("success");
        });
      }
    },
  },
  watch: {
    package() {
      ExtranetService.dollar2peso("USD").then((response) => {
        this.form.exchangePrice = response.rates.MXN.toFixed(6);
      });
      ExtranetService.getPaymentsPerPackage(this.package).then((response) => {
        this.payments = response;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/extranet/AddPayment.vue